import "../../../common/polyfills";
import * as React from "react";
import { useState } from "react";
import * as moment from 'moment';
import { sanitize } from 'dompurify';
import { IFormProps, IPaymentFormProps } from '../../../common/form/FormConfig';
import EventFormWithstripeInjector, { EventForm } from '../../GenericForm/Components/EventForm';
import { IStandardFormProps } from '../../GenericForm/Components/Constants';
import { StripeProvider, Elements } from 'react-stripe-elements';
import { useFetchCCEvent, IGetCCEventResponse } from "./EventRegFormHelper";

export interface CCEventRegFormProps extends IStandardFormProps, IFormProps, IPaymentFormProps {
    EventId?: number | string;
    Id?: number | string;
    hidePayModal?: () => void;
    formHeader?: string;
    formHeaderSubtext?: string
}

export function purifyHtml(html: HTMLElement | string) {
    let clean = sanitize(html, { FORBID_TAGS: ['style'], FORBID_ATTR: ['style'] });
    return { __html: clean }
}

interface IEventDetailProps {
    event: IEventProps
    className: string
}
export interface IEventProps {
    contentId: number
    sharedId?: number
    homeContentId?: number
    eventID: number
    startDate: Date
    endDate: Date
    name: string
    latitude: number
    longitude: number
    location: string
    totalTickets: number
    ticketsLeft: number
    maxTicketsPerRegistration: number
    registrationInputMask: number
    closingDateOfRegistration: Date
    notifyEmails: string
    autoRespondEmailFrom: string
    autoRespondEmailTemplate: string
    autoRespondEmailSubject: string
    ticketPrice: number
    description: string
    created?: Date
    modified?: Date
    deleted: boolean
}

const EventDetail = (props: IEventDetailProps) => {

    const { event } = props;
    var localStartDate = moment(event && event.startDate).format('dddd, DD MMM YYYY');
    var localStartTime = moment(event && event.startDate).format('h:mm a');
    var localEnd = moment(event && event.endDate).format('hh:mm a');
    var ticketPrice = event && event.ticketPrice ? event.ticketPrice : 0;
    return (
        <div className={props.className} >
            <h5 className="detail-label">Event Details:</h5>
            <div className="event-detail event-time">
                <div className="detail-value">
                    {localStartDate},<span className="time">{localStartTime} - {localEnd}</span>
                </div>
            </div>
            {event && event.location && <div className="event-detail event-location">
                <div className="detail-value">
                    <span className="location">{event.location}</span>
                </div>
            </div>}
            {ticketPrice > 0 && <div className="event-detail event-description">Ticket Price: ${ticketPrice}</div>}
            <hr />
            {event && event.description && <div className="event-detail event-description">
                <div className="detail-value" dangerouslySetInnerHTML={purifyHtml(event.description)}>
                </div>
            </div>}
        </div>)
}

export const CCEventRegForm = (props: CCEventRegFormProps) => {
    const {
        EventId,
        contentId,
        publishableKey,
        formHeader,
        formHeaderSubtext,
        paymentProviderName
    } = props;
    const [isSubmitted, setIsSubmitted] = useState(false)
    const eventData = useFetchCCEvent(EventId, contentId, isSubmitted)
    const ticketPrice = eventData && eventData.success && eventData.data.ticketPrice ? eventData.data.ticketPrice : 0;
    const maxTicketsPerRegistration = eventData && eventData.success && eventData.data.maxTicketsPerRegistration ? eventData.data.maxTicketsPerRegistration : 1;
    const ticketsLeft = eventData && eventData.success && eventData.data.ticketsLeft ? eventData.data.ticketsLeft : 0;
    const totalTickets = eventData && eventData.success && eventData.data.totalTickets ? eventData.data.totalTickets : 0;
    return <div className="row">
        <EventDetail className="col-12 col-md-6 event-info" event={eventData.data} />
        {paymentProviderName == "stripe" && publishableKey ? <><StripeProvider apiKey={publishableKey} >
            <Elements>
                <div className="col-12 col-md-6 event-reg-form">
                    <EventFormWithstripeInjector {...props} setIsSubmitted={setIsSubmitted} totalTickets={totalTickets} ticketsLeft={ticketsLeft} ticketCost={ticketPrice} maximumTicketsPerReg={maxTicketsPerRegistration} paymentProvider={paymentProviderName} fieldsAsColumn formHeader={formHeader} headerSubtext={formHeaderSubtext} />
                </div>
            </Elements>
        </StripeProvider ></>
            : <div className="col-12 col-md-6 event-reg-form">
                <EventForm {...props} ticketCost={ticketPrice} setIsSubmitted={setIsSubmitted} totalTickets={totalTickets} ticketsLeft={ticketsLeft} maximumTicketsPerReg={maxTicketsPerRegistration} paymentProvider={paymentProviderName} fieldsAsColumn formHeader={formHeader} headerSubtext={formHeaderSubtext} />
            </div>}
    </div>
}
